import { render, staticRenderFns } from "./MergedCustomersList.vue?vue&type=template&id=9497c2a2&scoped=true"
import script from "./MergedCustomersList.vue?vue&type=script&lang=js"
export * from "./MergedCustomersList.vue?vue&type=script&lang=js"
import style0 from "./MergedCustomersList.vue?vue&type=style&index=0&id=9497c2a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9497c2a2",
  null
  
)

export default component.exports